module.exports = __webpack_public_path__ + "static/media/Content-Preview-Frame.4e761560.svg";